export default "<p>\n  improvement-plan works!\n</p>\n"